import { React, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { page, userType } from "utils/constant";
import { UserContext } from "utils/getContext";
import { idCardHide } from 'utils/ruleType'
// import { base1 } from "api/config";
import user from "static/images/user.svg";
import 'static/css/BpmLoginCardContent.css';

/**
 * 用户登录卡片样式
 */
export function BpmLoginCardContent(props) {
  const navigate = useNavigate()
  const { userInfo, loginInfo } = useContext(UserContext)

  const { name, idNum, type } = userInfo ?? ''

  /** 身份证/公司代码 显示 */
  const userInfoHide = userInfo &&
    idNum.split('').map(
      (item, index) =>
        index > 5 && index < 15 ? '*' : item
    ).join('')

  /** 点击登记/注册 */
  function handleCardClick() {
    const urlParams = new URL(window.location.href)?.pathname;
    const spliceLength = urlParams.lastIndexOf("/")
    const pathname = urlParams?.slice(spliceLength + 1);
    // 已登录跳转到我的页面
    if (userInfo && pathname !== page.MINE) {
      navigate('/mine')
    }
    if (!userInfo) {
      // const context = '/app'
      // const { loginUrl, context, requestParams, returnUrl } = loginInfo
      const { loginUrl, requestParams, appLoginReturnUrl } = loginInfo || {}
      const login = `${loginUrl}${requestParams}&${appLoginReturnUrl}`
      if (login) {
        window.location.href = login
        // window.location.href = encodeURI(login)
      }


      // const baseUrl = window.location.origin;
      /*这个是跳转到微信地址的接口，重定向到登录页，本地用不了
      打包到环境上时用这个跳转*/
      // window.location.href = 'http://27.151.72.171:15512/hrss/getOpenId'
      // window.location.href = baseUrl + '/hrss/getOpenId'
      // const url = window.location.host
      // if (url === 'localhost:3000') {
      //   /*本地测试时用这个跳转*/
      //   navigate('/loginEnter')
      // } else {
      //   const baseUrl = window.location.origin;
      //   window.location.href = baseUrl + base1 + 'hrss/getOpenId'
      // }
    }
  }

  /** 证件号码显示区域 */
  function numShow() {
    if (userInfo) {
      return `${type === userType.USER ? '身份证' : '统一社会信用代码'}${userInfoHide}`
    } else {
      return '登录后可做更多操作'
    }
  }

  return (
    <div className="loginCard">
      <img src={user} alt="用户头像"></img>
      <div
        className="homeCardContent"
        onClick={handleCardClick}
      >
        <span href="/">{userInfo ? idCardHide(name, 1, name.length - 1) : '登录/注册'}</span>
        <p>
          {numShow()}
        </p >
      </div>
    </div>
  )
}